import styled from 'styled-components';

export const ReturnOrdersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReturnCardContentWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ReturnOrderWrapper = styled.div`
  border: 1px solid #ccc;
  background-color: #fff;
`;

export const Title = styled.h4`
  text-align: center;
  font-weight: 400;
`;

export const CardToggle = styled.div`
  position: absolute;
  right: 0;
  padding: 20px;
`;

export const Header = styled.div`
  cursor: pointer;
  position: relative;
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  background: #ececec;
  border-color: #ccc;
  padding: 16px 60px 16px 20px;
  border-bottom: ${({ opened }) => (opened ? '1px solid #ccc' : '1px solid transparent')};
`;

export const ActionBar = styled.div`
  display: flex;
  gap: 20px;
`;

export const ActionButton = styled.button`
  color: #337ab7;
  text-decoration: none;
  border: 0 none;
  background: transparent;
  padding: 0;
`;

export const DetailFieldsWrapper = styled.div`
  flex-grow: 1;
`;

export const DetailFieldTitle = styled.div`
  font-weight: bold;
`;

export const DetailFieldValue = styled.div`
  text-transform: capitalize;
`;
